import type { SerializerRegistry } from '@visualizer/types';

const version = 'v0_0_7';

const v0_0_7: SerializerRegistry = {
    version,
    binary: {},
};

export default v0_0_7;
